/* Sin / Con · arranca cuando se ve más de la mitad, una sola vez.
   Sin JS, con ?quieto=1 o con «menos movimiento» no se toca nada: se ve el 6 de enero, terminado. */
(() => {
  const quieto = new URLSearchParams(location.search).has("quieto") || matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (quieto || !("IntersectionObserver" in window)) return;

  document.querySelectorAll("[data-sincon]").forEach((el) => {
    el.dataset.estado = "espera";
    const io = new IntersectionObserver((entradas) => entradas.forEach((e) => {
      const mitad = e.intersectionRatio >= 0.5 || e.intersectionRect.height >= innerHeight * 0.5;
      if (!e.isIntersecting || !mitad) return;
      el.dataset.estado = "anima";
      io.disconnect();
    }), { threshold: [0, 0.25, 0.5, 0.75, 1] });
    io.observe(el);
  });
})();
